export const CHAINS = {
  BSCMAIN: 56,
  RINKEBY: 4,
  GOERLI: 5,
  HOMESTEAD: 1
};
